import axios from "axios";
import Cookies from "js-cookie";
import { logOut } from "@/services/auth";
import { getCurrentWorkspace } from "./workspaces";

export const httpService = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

httpService.interceptors.request.use(
  (config) => {
    const token = Cookies.get(process.env.REACT_APP_AUTH_TOKEN);
    const currentWorkspace = getCurrentWorkspace();

    const isSendMessage = config.headers["send-message"] === "true";

    if (token && !isSendMessage) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (currentWorkspace) {
      config.headers["workspace-id"] = currentWorkspace;
    }

    if (config.params && config.params["pagination[page]"]) {
      config.params["pagination[pageSize]"] =
        process.env.REACT_APP_PAGINATION_PAGE_SIZE;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      logOut();
      window.location.reload();
      return {};
    }
    return Promise.reject(error);
  }
);

export const eventSource = (path, queryParams) => {
  const token = Cookies.get(process.env.REACT_APP_AUTH_TOKEN);
  const currentWorkspace = getCurrentWorkspace();

  const params = new URLSearchParams(queryParams).toString();
  if (!token || !currentWorkspace) {
    throw new Error("Token ou Workspace ID ausente.");
  }

  return new EventSource(
    `${process.env.REACT_APP_BASE_URL}${path}?token=${encodeURIComponent(token)}&workspaceId=${currentWorkspace}${params ? `&${params}` : ""}`
  );
};
